import React, { Component } from 'react'
import './MainNavigationScreen.css'
import CookieBanner from '../components/CookieLawBanner'
import FooterComponent from '../components/FooterComponent'
import { RESELLER } from 'libs/roles';

export default class MainNavigatorScreen extends Component {
  render() {
    if (this.props) {
      const {
        auth
      } = this.props

      return (
        <div>
          <section>
            <div className="main-container container-fluid" style={{ padding: 0 }}>
              <CookieBanner />
              {this.props.children}
            </div>
          </section>
          {auth && auth.user && auth.user.role === RESELLER ? '' : <FooterComponent />}
        </div>
      );
    }
  }
}